import { render, staticRenderFns } from "./Escort.vue?vue&type=template&id=98808818"
import script from "./Escort.vue?vue&type=script&lang=ts"
export * from "./Escort.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports